module.exports = __webpack_public_path__ + "static/media/6a0fff37.jpg";